import { Component } from '@angular/core';

@Component({
    selector: 'gbc-input-container',
    templateUrl: './input-container.component.html',
    styleUrls: ['./input-container.component.scss'],
    standalone: true
})
export class InputContainerComponent {
}
